import { Typography } from '@material-ui/core'
import TenantIcon from '@material-ui/icons/Person'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/ProviderAddHeader.styles'

const ProviderAddHeader = () => {
  const classes = useStyles()
  const { providerCode } = useParams<{ providerCode: string }>()

  return (
    <div className={classes.header}>
      <TenantIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(providerCode ? 'Edit Provider' : 'Add New Provider')}
      </Typography>
    </div>
  )
}
export default ProviderAddHeader
